<cc-list-property-kind [propertyKind]="property.kind" [editable]="false"></cc-list-property-kind>

<input
  type="text"
  class="property-name-input"
  [class.readonly]="!editable"
  [readonly]="!editable"
  [value]="property.name"
  placeholder="Type Property Name..."
  i18n-placeholder="Type Property Name..."
  (keyup.enter)="onUpdateName($event.target.value)"
  (keyup.esc)="onCancelEditName($event.target)"
  (blur)="onUpdateName($event.target.value)"
  (mouseenter)="onMouseEnter($event.target)"
  (mouseleave)="onMouseLeave($event.target)"
/>

<div class="property-header-action">
  <ng-content></ng-content>
  <cc-dropdown
    placement="bottom-left"
    size="lg"
    *ngIf="editable"
    data-test="action-dropdown"
    autoClose="outside"
    #actionDropdown
  >
    <button type="button" class="action-dropdown-trigger" #selectPropertyKindButton dropdownToggle>
      <em class="cc-icon cc-icon-ellipsis-horizontal"></em>
    </button>

    <cc-dropdown-item
      (select)="this.onPropertyMoved.emit({ property, index, direction: directions.Left })"
      dropdownItem
      data-test="move-column-left"
      [disabled]="index === 0"
    >
      <div class="action-dropdown-item">
        <em class="cc-icon cc-icon-arrow-long-left sm-text-default-text" aria-hidden="true"></em>
        <span i18n>Move column left</span>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item
      (select)="this.onPropertyMoved.emit({ property, index, direction: directions.Right })"
      dropdownItem
      data-test="move-column-right"
      [disabled]="isLast"
    >
      <div class="action-dropdown-item">
        <em class="cc-icon cc-icon-arrow-long-right sm-text-default-text" aria-hidden="true"></em>
        <span i18n>Move column right</span>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item
      (select)="requestAddProperty(directions.Left)"
      [disabled]="hasReachedPlanLimit && !isUpgradeModalVisible"
      dropdownItem
      actionButtonData="addListProperty"
      data-test="insert-column-left"
    >
      <div class="action-dropdown-item">
        <em class="cc-icon cc-icon-plus sm-text-default-text" aria-hidden="true"></em>
        <span>Insert column left</span>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item
      (select)="requestAddProperty(directions.Right)"
      [disabled]="hasReachedPlanLimit && !isUpgradeModalVisible"
      dropdownItem
      actionButtonData="addListProperty"
      data-test="insert-column-right"
    >
      <div class="action-dropdown-item">
        <em class="cc-icon cc-icon-plus sm-text-default-text" aria-hidden="true"></em>
        <span i18n>Insert column right</span>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item (select)="onPropertyDeleted.emit()" dropdownItem data-test="delete-property">
      <div class="action-dropdown-item">
        <em class="cc-icon cc-icon-delete sm-text-default-red" aria-hidden="true"></em>
        <span i18n>Delete column</span>
      </div>
    </cc-dropdown-item>
  </cc-dropdown>
</div>
